// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"9512bea8","389":"baafae30","455":"dc347c27","977":"bca811e4"}[chunkId] + ".chunk.js";
};